module.exports = __webpack_public_path__ + "img/logo17.d039eb78.png";